import styles from './styles.module.scss';
import LineBreak from '../LineBreak';

function OficinasPlacesMobile() {
  return (
    <section className={styles.placesSection}>
      <div className={styles.oficinasPlacesContent}>
        <div className={styles.title}>
          Além dos colégios oficinas também podem acontecer em:
          <LineBreak />
          <strong>Condomínios, Clubes, Igrejas,</strong>
          <div className={styles.imgTall} />
          <LineBreak />
          ou outras localidades onde se possa reunir grupos de crianças e
          adolescentes.
          <LineBreak />
          <LineBreak />
          Também fazemos palestras para <strong>pais e professores.</strong>
          <div className={styles.imgRow}>
            <div className={styles.imgLeft} />
            <div className={styles.imgRight} />
          </div>
        </div>
      </div>
    </section>
  );
}

export default OficinasPlacesMobile;
